export default __webpack_public_path__ + "static/media/sp500-token.e42b9a3e.png";